import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { deleteRoleAssignmentMutation } from "../mutations";
import { accessManagementQuery } from "../queries";

/**
 * Hook to delete a role assignment from a user in the current tenant.
 * Automatically invalidates the access management query on success.
 *
 * @example
 * ```tsx
 * const { mutate, isPending } = useDeleteRoleAssignment();
 *
 * const handleRemove = () => {
 *   mutate({ user: userId, role: "site_manager:S0-site1" });
 * };
 * ```
 */
export function useDeleteRoleAssignment() {
  const apiConfig = useApiConfig();
  const queryClient = useQueryClient();

  const mutationApiConfig = {
    tenantId: apiConfig.tenant?.tenantId,
    apiBaseUrl: apiConfig.tenant?.apiBaseUrl,
    authenticatedFetch: apiConfig.authenticatedFetch,
  };

  return useMutation({
    ...deleteRoleAssignmentMutation(mutationApiConfig, {}),
    onSuccess: () => {
      const queryKey = accessManagementQuery(apiConfig, {}).queryKey;
      void queryClient.invalidateQueries({ queryKey });
    },
  });
}
